import React, { useState, useRef, Fragment, } from "react";
import "./index.scss";

const NavPanel = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { input_fields, selectedData } = props;
  const ref = useRef(null);
  const handleScrollClick = (index, id) => {
    setActiveIndex(index);
    const sub_id = `${id}-${
      selectedData?.subworkflows?.findIndex(
        (e) => e._id === selectedData?.commonTabKey
      ) || 0
    }`;
    (document.getElementById(sub_id) &&
      document.getElementById(sub_id)?.scrollIntoView({
        behavior: "smooth",
      })) ||
      document.getElementById(sub_id + 0)?.scrollIntoView({
        behavior: "smooth",
      });
  };

  const scroll = (scrollOffset) => {
    ref.current.scrollLeft += scrollOffset;
  };

  const scrollToLeft = (scrollOffset) => {
    ref.current.scrollLeft -= scrollOffset;
  };

  const shouldShowField = (show) => {
    if (show) {
      return !!eval(show);
    }
    return true;
  };

  const showArrows = (fields) =>{

    const firstItem = document.querySelector('.first-item')
    const leftArrow = document.querySelector('.left_nav_panel_button')

    const rightArrowCallback = (entries) =>{
      const [entry] = entries
      if(!entry.isIntersecting){
        leftArrow.classList.remove('d-none')
      }
      else{
        leftArrow.classList.add('d-none')
      }
    }

    const rightArrowConfig = {
      root:document.querySelector('.scrollmenu'),
      threshold:0.1,
    }

    const obsContainer = new IntersectionObserver(rightArrowCallback,rightArrowConfig);
    if(firstItem){
      obsContainer.observe(firstItem)
    }

  }


  return (
      <div className="nav_panel position-sticky top-0 pb-3 bg-theme-grey z-index-5 d-none d-lg-flex">
          <div className="left_nav_panel_button d-none">
              <button onClick={() => scrollToLeft(500)} className="dart">
                 <span>
                 <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="text-theme" width="6" height="12" viewBox="0 0 6 12"><path id="Path_54090" data-name="Path 54090" d="M5.181,5.85a.727.727,0,0,1-.513-.21L.213,1.227A.714.714,0,0,1,.213.21a.731.731,0,0,1,1.026,0l3.942,3.9L9.123.211a.731.731,0,0,1,1.026,0,.713.713,0,0,1,0,1.016L5.694,5.639A.727.727,0,0,1,5.181,5.85Z" transform="translate(5.85) rotate(90)"></path></svg>
                 </span>
              </button>
          </div>
          <div className="scrollmenu" ref={ref} onScroll={showArrows(input_fields)}>
              {input_fields.map((item, index) => {
                // console.log(item?.show);
                  return (
                      <Fragment key={index}>
                          {(shouldShowField(item.show) && (
                              <a
                                  className={`${
                                      index == activeIndex && 'active'
                                  } ${ index === 0 ? 'first-item':''} `}
                                  onClick={() =>
                                      handleScrollClick(index, item.id)
                                  }
                              >     
                                  {index === activeIndex && (
                                      <div className="px-2"></div>
                                  )}
                                  <div className="fs-16px fw-semibold text-truncate"> &nbsp; {`${item.title}`}</div>
                              </a>
                          )) || <></>}
                      </Fragment>
                  );
              })}
          </div>

          <div className="right_nav_panel_button">
              <button onClick={() => scroll(500)} className="dart">
                 <span>
                 <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="text-theme" width="6" height="12" viewBox="0 0 6 12"><path id="Path_53944" data-name="Path 53944" d="M5.181,0a.727.727,0,0,0-.513.21L.213,4.623a.714.714,0,0,0,0,1.016.731.731,0,0,0,1.026,0l3.942-3.9,3.942,3.9a.731.731,0,0,0,1.026,0,.713.713,0,0,0,0-1.016L5.694.21A.727.727,0,0,0,5.181,0Z" transform="translate(5.85) rotate(90)"></path></svg>
                 </span>
              </button>
          </div>
      </div>
  );
};

export default NavPanel;
